import axios from 'axios'
import { COGNITO_MESSAGE_ACTIONS } from '../util/cognito.util'
import { SSO_LOGIN_OPTIONS } from '../util/sso.util'

const ROOT = process.env.REACT_APP_AUGMENTT_API_URL

export const USERS_URL = `${ROOT}/user`
export const ORGANIZATION_URL = `${ROOT}/organization`
export const INVITE_URL = `${ROOT}/tools/cognito/invite`
export const TOGGLE_URL = `${ROOT}/tools/cognito/mfa`
export const COGNITO_RESEND_INVITE = `${ROOT}/tools/cognito/invite-resend`

/* eslint-disable camelcase */
export function getUserById(amazon_id) {
  return axios.post(`${ORGANIZATION_URL}/user/amazon`, { amazon_id })
}
/* eslint-enable camelcase */

export function inviteUser(user) {
  const isMicrosoftOnly = user.login_options === SSO_LOGIN_OPTIONS.MICROSOFT_SSO
  return axios.post(INVITE_URL, {
    amazon_id: user.email,
    username: user.email,
    email: user.email,
    role: user.role,
    first_name: user.first_name,
    last_name: user.last_name,
    organization_string: user.Customer.organization.toString(),
    customer_string: user.Customer.id.toString(),
    login_options: user.login_options,
    message_action: isMicrosoftOnly ? COGNITO_MESSAGE_ACTIONS.SUPPRESS : user.message_action,
    send_sso_invite: user.send_sso_invite ?? isMicrosoftOnly,
  })
}

export function resendUserInvitation(email) {
  return axios.post(COGNITO_RESEND_INVITE, {
    email,
  })
}

export function toggleMFA(user) {
  return axios.post(TOGGLE_URL, {
    customer: user.Customer.id,
    email: [user.email],
  })
}

/**
 * @param {object} [params]
 * @param {boolean} [params.includeM365Properties] Adds linked users' Microsoft 365 properties, read from the
 * latest collected snapshot.
 */
export function getSystemUsers(orgId, params) {
  return axios.get(`${ORGANIZATION_URL}/${orgId}/user`, { params })
}

export function addSystemUser(organizationId, data) {
  return axios.post(`${ORGANIZATION_URL}/${organizationId}/user`, data)
}

export function updateSystemUser(organizationId, userId, data) {
  return axios.put(`${ORGANIZATION_URL}/${organizationId}/user/${userId}`, data)
}

export function deleteSystemUser(organizationId, userId, replacementUserId) {
  return axios.delete(`${ORGANIZATION_URL}/${organizationId}/user/${userId}`, { data: { replacementUserId } })
}

export function updateUserProfile(data) {
  return axios.put(`${USERS_URL}/profile`, data)
}

export function checkAgreement(user) {
  return axios.put(`${USERS_URL}/${user.id}/agreement`, {
    type: 'EULA',
  })
}

export function signAgreement(user) {
  return axios.post(`${USERS_URL}/${user.id}/agreement`, {
    version: user.eula.latestVersion,
    type: 'EULA',
  })
}

export function postLogin(organization, userId, loginType = 'user_login_password') {
  return axios.post(`${ORGANIZATION_URL}/auth/login`, { organization, userId, loginType })
}

export function getContactRoles() {
  return axios.get(`${USERS_URL}/contact-roles`)
}
export function assignTechnicalPrimary(userId) {
  return axios.post(`${USERS_URL}/contact-roles`, { userId })
}
export function removeTechnicalPrimary(userId, replacementUserId) {
  return axios.delete(`${USERS_URL}/contact-roles/${userId}`, { data: { replacementUserId } })
}
export function promptContactCampaign() {
  return axios.post(`${USERS_URL}/contact-campaign`)
}
export function dismissContactCampaign(campaignId) {
  return axios.put(`${USERS_URL}/contact-campaign`, { campaignId })
}
export function declineContactCampaign(campaignId) {
  return axios.put(`${USERS_URL}/contact-campaign`, { campaignId, declined: true })
}
